<tlk-card *ngIf="isSectionVisible$ | async" [padding]="0" class="rx-intuitive-scan-options-card" data-testid="rx-intuitive-scan-options">
	<div tlkCardContent>
		<div class="rx-intuitive-scan-options-container">
			<!-- NIRI Capture -->
			<tlk-slide-toggle
				*ngIf="isNiriCaptureVisible$ | async"
				[id]="'scan-option-niri-toggle'"
				name="niriCaptureToggle"
				labelPosition="right"
				[isDisabled]="(isNiriCaptureDisabled$ | async) || false"
				[checked]="isNiriCaptureChecked$ | async"
				(changeEvent)="onNiriCaptureUpdate($event.checked)"
			>
				{{ 'ScanOptions.NIRICapture' | translate }}
			</tlk-slide-toggle>

			<!-- New Sleeve Attached -->
			<tlk-slide-toggle
				*ngIf="isSleeveConfirmationVisible$ | async"
				[id]="'scan-option-sleeve-toggle'"
				name="sleeveToggle"
				labelPosition="right"
				[isDisabled]="(isSleeveConfirmationReadOnly$ | async) || false"
				[checked]="isSleeveChecked$ | async"
				(changeEvent)="onSleeveConfirmationUpdate($event.checked)"
			>
				{{ 'ScanOptions.NewSleeveAttached' | translate }}
			</tlk-slide-toggle>

			<!-- Ortho model / iCast -->
			<tlk-slide-toggle
				*ngIf="isOrthoModelIcastVisible$ | async"
				[id]="'scan-option-icast-toggle'"
				name="icastToggle"
				labelPosition="right"
				[isDisabled]="(isOrthoModelIcastDisabled$ | async) || false"
				[checked]="isOrthoModelIcastChecked$ | async"
				(changeEvent)="onOrthoModelIcastUpdate($event.checked)"
			>
				{{ 'OrderSection.IcastOrthoModel' | translate }}
			</tlk-slide-toggle>

			<!-- Resto Multi Bite -->
			<tlk-slide-toggle
				*ngIf="isRestoMultiBiteVisible$ | async"
				[id]="'scan-option-restoMultiBite-toggle'"
				name="restoMultiBiteToggle"
				labelPosition="right"
				[isDisabled]="isDisabled$ | async"
				[checked]="(isRestoMultiBiteSelected$ | async) ?? false"
				(changeEvent)="onRestoMultiBiteUpdate($event.checked)"
			>
				{{ 'ScanOptions.MultiBite' | translate }}
			</tlk-slide-toggle>

			<!-- Pre Treatment Scan -->
			<tlk-slide-toggle
				*ngIf="isPreTreatmentVisible$ | async"
				[id]="'scan-option-pre-treatment-toggle'"
				name="preTreatmentToggle"
				labelPosition="right"
				[isDisabled]="(isPreTreatmentDisabled$ | async) || false"
				[checked]="isPreTreatmentChecked$ | async"
				(changeEvent)="onPreTreatmentUpdate($event.checked)"
			>
				{{ 'ScanOptions.PreTreatmentScan' | translate }}
			</tlk-slide-toggle>

			<!-- Denture Copy Scan -->
			<tlk-slide-toggle
				*ngIf="isDentureCopyScanVisible$ | async"
				[id]="'scan-option-dentureCopyScan-toggle'"
				name="dentureCopyScanToggle"
				labelPosition="right"
				[isDisabled]="(isDentureCopyScanDisabled$ | async) || false"
				[checked]="isDentureCopyScan$ | async"
				(changeEvent)="onDentureCopyScanUpdate($event.checked)"
			>
				{{ 'ScanOptions.DentureCopyScan' | translate }}
			</tlk-slide-toggle>

			<!-- Emergence Profile -->
			<tlk-slide-toggle
				*ngIf="isEmergenceProfileVisible$ | async"
				[id]="'scan-option-emergenceProfile-toggle'"
				name="emergenceProfileToggle"
				labelPosition="right"
				[isDisabled]="(isEmergenceProfileDisabled$ | async) || false"
				[checked]="isEmergenceProfileChecked$ | async"
				(changeEvent)="onEmergencyProfileUpdate($event.checked)"
			>
				{{ 'ScanOptions.EmergenceProfile' | translate }}
			</tlk-slide-toggle>

			<!-- Multi Bite -->
			<tlk-slide-toggle
				*ngIf="isMultiBiteVisible$ | async"
				[id]="'scan-option-multiBite-toggle'"
				name="multiBiteToggle"
				labelPosition="right"
				[isDisabled]="isDisabled$ | async"
				[checked]="isMultiBiteSelected$ | async"
				(changeEvent)="onMultiBiteUpdate($event.checked)"
			>
				{{ 'ScanOptions.MultiBite' | translate }}
			</tlk-slide-toggle>

			<!-- Palatal Scanning Feedback -->
			<tlk-slide-toggle
				*ngIf="isPalatalFeedbackVisible$ | async"
				[id]="'scan-option-palatalFeedback-toggle'"
				name="palatalFeedbackToggle"
				labelPosition="right"
				[isDisabled]="isDisabled$ | async"
				[checked]="isPalatalFeedbackChecked$ | async"
				(changeEvent)="onPalatalFeedbackUpdate($event.checked)"
			>
				{{ 'ScanOptions.PalatalScanningFeedback' | translate }}
			</tlk-slide-toggle>
			<div
				*ngIf="(isAdditionalBitesVisible$ | async)"
				id="additional-bites"
				class="additional-bites">
			<div class="additional-bite" *ngFor="let bite of additionalBites" [class.active]="isBiteSelected(bite.id) | async"  [id]= "bite.textKey.toLowerCase()"
				(click)="onAdditionalBiteToggle(bite.id)">
				<img [src]="getAdditionalBiteImageUrl(bite.img) | staticFilesEndpoint" class="bite-img" alt="checked"/>
				<span>{{ 'RestoMultiBite.' + bite.textKey | translate }}</span>
				<tlk-checkbox
					[isDisabled]="(isDisabled$ | async)"
					[checked]="(isBiteSelected(bite.id) | async) ?? false"
					(changeEvent)="onAdditionalBitesUpdate($event.checked, bite.id)"
					(click)="$event.stopPropagation()"
					[class.read-only]="isReadOnly$ | async">
				</tlk-checkbox>
			</div>
			</div>
		</div>
		<tlk-banner *ngIf="isMultiBiteInfoBannerVisible$ | async" type="warning">
			<span tlkBannerBody>{{ 'ScanOptions.MultiBiteInformationMessage' | translate }}</span>
		</tlk-banner>
	</div>
</tlk-card>
